// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#video-play-wrapper[data-v-6fc015c4]{width:100%;margin:auto;border-radius:10px}", "",{"version":3,"sources":["webpack://src/components/PlayVideoModal.vue"],"names":[],"mappings":"AAAA,qCAAqC,UAAU,CAAC,WAAW,CAAC,kBAAkB","sourcesContent":["#video-play-wrapper[data-v-6fc015c4]{width:100%;margin:auto;border-radius:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
